// extracted by mini-css-extract-plugin
export var avatar = "_of-3";
export var avatarContainer = "_of-2";
export var avatarSpacer = "_of-5";
export var avatarSpacerContainer = "_of-4";
export var avatarStackContainer = "_of-1";
export var bubble = "_of-0";
export var remainderBubble = "_of-6";